import {  Box, CircularProgress } from '@mui/material';


const LoadingProgress = () => {


  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="90vh" 
    >
      <CircularProgress />
    </Box>
  );
};

export default LoadingProgress;
